import { Component, Directive, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { AutomationsSideDrawerService } from '../automations-side-drawer-service';

@Directive({
  selector: 'automata-side-drawer-content, [automata-side-drawer-content], [appSideDrawerContent]',
  standalone: true,
})
export class AutomataSideDrawerContentDirective {
  @HostBinding('class') className = 'side-drawer-content';
}

@Directive({
  selector: 'automata-side-drawer-footer, [automata-side-drawer-footer], [appSideDrawerFooter]',
  standalone: true,
})
export class AutomataSideDrawerFooterDirective {
  @HostBinding('class') className = 'side-drawer-footer';
}

@Directive({
  selector: 'automata-side-drawer-title-actions, [automata-side-drawer-title-actions], [appSideDrawerTitleActions]',
  standalone: true,
})
export class AutomataSideDrawerTitleActionsDirective {
  @HostBinding('class') className = 'side-drawer-title-actions';
}

@Directive({
  selector:
    'automata-side-drawer-pre-title-actions, [automata-side-drawer-pre-title-actions], [appSideDrawerPreTitleActions]',
  standalone: true,
})
export class AutomataSideDrawerPreTitleActionsDirective {
  @HostBinding('class') className = 'side-drawer-pre-title-actions';
}

@Component({
  selector: 'automata-closing-side-drawer',
  templateUrl: './automata-closing-side-drawer.component.html',
  styleUrls: ['./automata-closing-side-drawer.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, MatToolbarModule, TranslateModule],
})
export class AutomataClosingSideDrawerComponent implements OnInit {
  @Input() title: string;
  @Input() preventClose: boolean;

  sideNavWidth = 400;
  canResize = true;

  resizingEvent = {
    isResizing: false,
    startingCursorX: 0,
    startingWidth: 0,
  };

  constructor(private readonly sideDrawerService: AutomationsSideDrawerService) {}

  ngOnInit() {
    if (window.innerWidth <= 425) {
      this.sideNavWidth = window.innerWidth;
      this.canResize = false;
    }
  }

  closeSideDrawer(): void {
    this.sideDrawerService.close();
  }

  startResizing(event: MouseEvent): void {
    if (!this.canResize) {
      return;
    }
    this.resizingEvent = {
      isResizing: true,
      startingCursorX: event.clientX,
      startingWidth: this.sideNavWidth,
    };
  }

  @HostListener('window:mousemove', ['$event'])
  updateSidenavWidth(event: MouseEvent) {
    if (!this.resizingEvent.isResizing) {
      return;
    }
    const cursorDeltaX = -1 * (event.clientX - this.resizingEvent.startingCursorX);

    let newWidth = this.resizingEvent.startingWidth + cursorDeltaX;
    if (newWidth > window.innerWidth - 50) {
      newWidth = window.innerWidth - 50;
    }
    if (newWidth < 200) {
      newWidth = 200;
    }

    // 3. Set the new width
    this.sideNavWidth = newWidth;
  }

  @HostListener('window:mouseup')
  stopResizing() {
    this.resizingEvent.isResizing = false;
  }
}
